import { Settings } from '@mui/icons-material';
import CancelIcon from '@mui/icons-material/Cancel';
import ToggleOffRoundedIcon from '@mui/icons-material/ToggleOffRounded';
import ToggleOnRoundedIcon from '@mui/icons-material/ToggleOnRounded';
import {
  IconButton,
  Button,
  CircularProgress,
  Modal,
  List,
  ListItem,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { ThemeProvider } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { useThunkDispatch, useTypedSelector } from 'hooks';
import React, { useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { allReports, updateReport } from '../../redux/actions/reports.actions';
import { Report } from '../../types/api/responses';
import { getModalStyle, Styles, myTheme } from '../Tools';

const SIZE = 100,
  INITPAGE = 1;

export function FilterReportMap() {
  const classes = Styles();
  const dispatch = useThunkDispatch();
  const [loading, setLoading] = useState(false);
  const [modalStyle] = useState(getModalStyle(40, 20));
  const [openModal, setOpenModal] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const reports = useTypedSelector((state) => state.reports.reports.reports);
  const [items, setItems] = useState(reports || []);
  const [originalItems, setOriginalItems] = useState(reports || []);
  const [isModified, setIsModified] = useState(false);

  useEffect(() => {
    dispatch(allReports({ page: INITPAGE, size: SIZE }));
  }, [dispatch]);

  useEffect(() => {
    if (reports) {
      setItems(reports);
      setOriginalItems(reports);
    }
  }, [reports]);

  useEffect(() => {
    const hasChanges = JSON.stringify(items) !== JSON.stringify(originalItems);
    setIsModified(hasChanges);
  }, [items, originalItems]);

  const handleDragEnd = (result: any) => {
    if (!result.destination) return;

    const reorderedItems = Array.from(items);
    const [movedItem] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, movedItem);

    const updatedItems = reorderedItems.map((item, index) => ({
      ...item,
      order: index + 1,
    }));

    setItems(updatedItems);
  };

  const handleOpenModal = () => setOpenModal(true);

  const handleCloseModal = () => {
    if (isModified) {
      setOpenDialog(true);
    } else {
      setOpenModal(false);
    }
  };

  const handleConfirmClose = async () => {
    dispatch(allReports({ page: INITPAGE, size: SIZE }));
    setOpenModal(false);
    setOpenDialog(false);
  };

  const handleCancelClose = () => {
    setOpenDialog(false);
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      await new Promise((resolve) => setTimeout(resolve, 2000));
      dispatch(updateReport(items));
      setOriginalItems(items);
      setIsModified(false);
      setOpenModal(false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Button
        className={classes.submit}
        disabled={loading}
        style={{ color: '#343c89', marginRight: '5px', height: 'fit-content' }}
        onClick={handleOpenModal}
        startIcon={<Settings />}
      >
        Configurar
      </Button>
      <ThemeProvider theme={myTheme}>
        <Modal
          open={openModal}
          onClose={() => {}}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '1000px',
              maxWidth: '95vw',
              height: 'auto',
              maxHeight: '90vh',
              backgroundColor: 'white',
              boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)',
              borderRadius: '8px',
              outline: 'none',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              padding: '0',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '16px 24px',
                borderBottom: '1px solid #e0e0e0',
                flexShrink: 0,
                backgroundColor: '#f5f5f5',
              }}
            >
              <div>
                <Box display="flex" alignItems="center" gap={1} sx={{ color: 'black' }}>
                  <IconButton size="small" sx={{ color: 'black' }}>
                    <Settings />
                  </IconButton>
                  <h4>CONFIGURAR REPORTE</h4>
                </Box>
              </div>
              <div>
                <Button
                  variant={'outlined'}
                  color={'error'}
                  onClick={handleCloseModal}
                  style={{ color: '#dc3545', marginRight: '5px' }}
                >
                  <CancelIcon />
                </Button>
              </div>
            </div>
            <div style={{ 
              flex: '1 1 auto', 
              overflowY: 'auto', 
              padding: '16px 24px',
              maxHeight: 'calc(90vh - 150px)',
              minHeight: '200px',
              scrollbarWidth: 'thin',
              msOverflowStyle: 'none',
              scrollbarColor: '#888 #f1f1f1'
            }}>
              <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="reports">
                  {(provided) => (
                    <List
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        margin: 0,
                      }}
                    >
                      {items.map((item, index) => (
                        <Draggable key={item.code} draggableId={item.code} index={index}>
                          {(draggableProvided, snapshot) => (
                            <ListItem
                              ref={draggableProvided.innerRef}
                              {...draggableProvided.draggableProps}
                              {...draggableProvided.dragHandleProps}
                              component={Paper}
                            {...draggableProvided.dragHandleProps}
                            style={{
                              ...draggableProvided.draggableProps.style,
                              marginBottom: '8px',
                              padding: '8px',
                              background: snapshot.isDragging
                                ? 'rgba(116,121,175,0.45)'
                                : '#f7f7f7',
                              border: '1px solid #e0e0e0',
                              borderRadius: '8px',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              opacity: snapshot.isDragging ? 0.85 : 1,
                              boxShadow: snapshot.isDragging
                                ? '0px 4px 8px rgba(0, 0, 0, 0.2)'
                                : 'none',
                              zIndex: snapshot.isDragging ? 9999 : 'auto',
                              transition: 'all 0.3s ease',
                            }}
                          >
                            <div
                              style={{
                                flex: 2,
                                display: 'flex',
                                flexDirection: 'column',
                                marginRight: '5px',
                              }}
                            >
                              <div
                                style={{
                                  fontSize: '14px',
                                  color: 'rgb(78,80,78)',
                                  marginTop: '-5px',
                                  marginBottom: '5px',
                                }}
                              >
                                {`Orden: ${item.order} | Código: ${item.code} | Origen: ${item.originType}`}
                              </div>
                              <TextField
                                label="Descripción"
                                color="primary"
                                value={item.name}
                                onChange={(e) => {
                                  const updatedItems = [...items];
                                  updatedItems[index] = {
                                    ...updatedItems[index],
                                    name: e.target.value,
                                  };
                                  setItems(updatedItems);
                                }}
                                variant="outlined"
                                style={{
                                  marginBottom: '8px',
                                  borderRadius: '4px',
                                  width: '100%',
                                }}
                              />
                            </div>
{/*                            <div
                              style={{
                                flex: 2,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                marginRight: '5px',
                              }}
                            >
                              <div
                                style={{
                                  fontSize: '14px',
                                  color: 'rgb(78,80,78)',
                                  marginTop: '5px',
                                  marginBottom: '5px',
                                }}
                              ></div>
                              {item.originType === 'Web' && (
                                <FormControl
                                  sx={{ m: 1, minWidth: 120 }}
                                  style={{ width: '90%' }}
                                >
                                  <InputLabel id="demo-simple-select-label">
                                    Comparativo
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    variant="outlined"
                                    label="Comparativo"
                                    onChange={(e) => {
                                      const updatedItems = [...items];
                                      const updatedItemIndex = index;
                                      const selectedValue = e.target.value as string;

                                      updatedItems[updatedItemIndex] = {
                                        ...updatedItems[updatedItemIndex],
                                        compare: selectedValue,
                                      };

                                      const targetIndex = updatedItems.findIndex(
                                        (item) => item.code === selectedValue,
                                      );
                                      if (targetIndex !== -1) {
                                        updatedItems[targetIndex] = {
                                          ...updatedItems[targetIndex],
                                          compare: updatedItems[updatedItemIndex].code,
                                        };
                                      }

                                      setItems(updatedItems);
                                    }}
                                    value={items[index]?.compare || ''}
                                  >
                                    <MenuItem value="">
                                      <em>Seleccione...</em>
                                    </MenuItem>
                                    {items
                                      .filter((item) => item.originType === 'AS400')
                                      .filter((as400Item) => {
                                        const isSelected = items.some(
                                          (webItem) =>
                                            webItem.originType === 'Web' &&
                                            webItem.compare === as400Item.code,
                                        );
                                        return (
                                          !isSelected ||
                                          as400Item.code === items[index]?.compare
                                        );
                                      })
                                      .map((item) => (
                                        <MenuItem
                                          value={item.code || ''}
                                          key={item.code || 'default-key'}
                                        >
                                          {item.name || 'No hay nombre'}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                </FormControl>
                              )}
                            </div>*/}
                            <div
                              style={{ display: 'flex', gap: '10px', alignItems: 'center' }}
                            >
                              <Button
                                onClick={() => {
                                  const updatedItems = [...items];
                                  updatedItems[index] = {
                                    ...updatedItems[index],
                                    show: !updatedItems[index].show,
                                  };
                                  setItems(updatedItems);
                                }}
                                style={{
                                  borderRadius: '50%',
                                  padding: '10px',
                                }}
                              >
                                {item.show ? (
                                  <ToggleOnRoundedIcon
                                    style={{ color: 'rgb(0 128 0)', fontSize: '40px' }}
                                  />
                                ) : (
                                  <ToggleOffRoundedIcon
                                    style={{ color: 'rgb(78,80,78)', fontSize: '40px' }}
                                  />
                                )}
                              </Button>
                            </div>
                          </ListItem>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                    </List>
                  )}
                </Droppable>
              </DragDropContext>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                padding: '16px 24px',
                borderTop: '1px solid #e0e0e0',
                backgroundColor: '#f5f5f5',
              }}
            >
              <Button
                variant="contained"
                style={{
                  backgroundColor: isModified ? '#343c89' : '#ccc',
                  color: isModified ? 'white' : '#666',
                  minWidth: '150px',
                  height: '40px',
                  textTransform: 'none',
                  fontWeight: '500',
                  fontSize: '14px',
                }}
                disabled={!isModified || loading}
                onClick={handleSave}
              >
                Guardar Cambios {loading && <CircularProgress size={20} />}
              </Button>
            </div>
          </div>
        </Modal>
      </ThemeProvider>
      <Dialog
        open={openDialog}
        onClose={handleCancelClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'Cambios no guardados'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Tienes cambios no guardados. ¿Estás seguro de que deseas cerrar sin guardar?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelClose}>Cancelar</Button>
          <Button onClick={handleConfirmClose} autoFocus>
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
